import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { StatusAPIModel } from 'src/app/models/api.model'
import { getStatusListFromState } from 'src/app/store/selector/initialize.selector'
import { AppState } from 'src/app/store/state/app.state'

@Component({
  selector: 'app-status-selector',
  templateUrl: './status-selector.component.html',
  styleUrls: ['./status-selector.component.scss']
})
export class StatusSelectorComponent implements OnInit, OnChanges {
  statusFormControl: FormControl = new FormControl('')
  @Output() onSelect: EventEmitter<StatusAPIModel> = new EventEmitter<StatusAPIModel>()
  @Output() onStatusChange: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output() fetchStatusList = new EventEmitter<StatusAPIModel[]>()
  @Input() selectedStatus: string
  @Input() categoryName: string
  @Input() subCategoryName: string
  @Input() moduleName: string
  @Input() code: string
  @Input() isRequired = false
  @Input() emitStatusList: boolean = false

  statusList: StatusAPIModel[] = []
  getStatusListFromState$: Subscription

  constructor(private appState: Store<AppState>, private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.categoryName && this.moduleName && this.code && this.statusList.length === 0) {
      this.getStatusListFromState$ = this.appState.select('initialize').subscribe(({ taskTypes }) => {
        this.statusList = taskTypes?.[this.categoryName]?.[this.subCategoryName]?.[this.moduleName]?.find(
          (task: { code: string }) => task.code === this.code
        )?.statusList

        if (this.emitStatusList) {
          this.fetchStatusList.emit(this.statusList)
        }
      })
    }

    if (this.selectedStatus) {
      this.statusFormControl.setValue(this.selectedStatus)
    }

    if (this.isRequired) {
      this.statusFormControl.setValidators(Validators.required)
    }
    this.cd.detectChanges()
  }

  ngOnInit(): void {}

  onSelectChange(selectedValue: string) {
    const selectedStatus = this.statusList.filter(status => status.code === selectedValue)?.[0]
    this.onSelect.emit(selectedStatus)
    const statusChange = this.selectedStatus === selectedValue ? false : true
    this.onStatusChange.emit(statusChange)
  }

  ngOnDestroy() {
    this.getStatusListFromState$?.unsubscribe()
  }
}
